import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasToken } from './adminApi';

export default function RequireAuth({ children }) {
  if (!hasToken()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
